import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { GovSkeleton } from '@gov-design-system-ce/react';
import { LocalizeNameSpaceTypes, useGlobalLocale } from '@gov-nx/core/service';
import { ContentLayout, LayoutGap } from '@gov-nx/ui/web';
import { generateRandomNumber } from '@gov-nx/utils/common';
import { GridSkeleton } from '../../../Skeleton/GridSkeleton';

const Skeleton = ({
	rows,
	randomStartWidth,
}: {
	rows: number;
	randomStartWidth: number;
}) => {
	const memoizedRows = useMemo(
		() => Array.from({ length: rows }).map((_, i) => i),
		[rows]
	);

	const { t } = useGlobalLocale();

	const ariaLabel = t('loading.wcag.processing');

	return memoizedRows.map((rowsIdx) => (
		<div
			key={rowsIdx}
			className="flex justify-between gap-4 p-5 mt-0!">
			<GovSkeleton
				height="26px"
				width={generateRandomNumber(randomStartWidth, 240) + 'px'}
				aria-label={ariaLabel}
			/>
			<GovSkeleton
				height="24px"
				width="24px"
				shape="circle"
				aria-label={ariaLabel}
			/>
		</div>
	));
};
export const RegisterSVDetailSkeleton = () => {
	const { t } = useTranslation(LocalizeNameSpaceTypes.Global);

	return (
		<LayoutGap>
			<ContentLayout>
				<div className="flex justify-between gap-4 p-5">
					<GovSkeleton
						height="26px"
						width="73px"
						aria-label={t('loading.wcag.processing')}
					/>
					<GovSkeleton
						height="24px"
						width="24px"
						shape="circle"
						aria-label={t('loading.wcag.processing')}
					/>
				</div>
				<div className="mt-2! mx-5! mb-5!">
					<GridSkeleton rows={15} />
				</div>
				<Skeleton
					rows={6}
					randomStartWidth={40}
				/>
			</ContentLayout>
			<ContentLayout>
				<Skeleton
					rows={4}
					randomStartWidth={140}
				/>
			</ContentLayout>
			<ContentLayout>
				<LayoutGap>
					<GovSkeleton
						height="30px"
						width="180px"
						aria-label={t('loading.wcag.processing')}
					/>
					<div>
						<GovSkeleton
							height="20px"
							width="100%"
							aria-label={t('loading.wcag.processing')}
						/>
						<GovSkeleton
							height="20px"
							width="100%"
							aria-label={t('loading.wcag.processing')}
						/>
						<GovSkeleton
							height="20px"
							width="30%"
							aria-label={t('loading.wcag.processing')}
						/>
					</div>
					<GovSkeleton
						height="40px"
						width="290px"
						aria-label={t('loading.wcag.processing')}
					/>
				</LayoutGap>
			</ContentLayout>
		</LayoutGap>
	);
};
